import React from "react";
import { useRef } from "react";
import { Button, Modal, FormControl, ControlLabel, OverlayTrigger, Popover } from "react-bootstrap";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import util from "./../../lib/util.js";
import immutable from "immutable";
import moment from "moment";
import PtoListByTimecard from "./../pto/pto-list-by-timecard.jsx";
import PtoDetail from "./../pto/pto-detail.jsx";

export default class MiscGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogMode: "new",
            dialogTop: 0,
            editedExpense: null,
            showMiscCodeDescription: false,
            miscCodeDescription: "",
            showScheduleHoursDay: false,
            scheduleHoursDay: null,
            showPtoDialog: false,
            showPtoListDialog: false,
            showMiscDialog: false,
            ptoDialogTitle: "",
            ptoAction: "",
            miscDialogTitle: null,
            miscDialogContent: null,
            totalHoursDaily: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],  // [Sun, Mon... Sat]
            totalHours: 0.0,
            newExpenses: []
        };

        this.openMisc = this.openMisc.bind(this);
        this.closeMisc = this.closeMisc.bind(this);
        this.onSaveMisc = this.onSaveMisc.bind(this);
        this.onSaveEmptyMisc = this.onSaveEmptyMisc.bind(this);
        this.onDeleteMisc = this.onDeleteMisc.bind(this);
        this.updateTotal = this.updateTotal.bind(this);
        this.onReasonSelected = this.onReasonSelected.bind(this);
        this.onSavePto = this.onSavePto.bind(this);
        this.openPto = this.openPto.bind(this);
        this.approvePto = this.approvePto.bind(this);
        this.closePto = this.closePto.bind(this);
        this.deletePtoLine = this.deletePtoLine.bind(this);
        this.hasUnapprovedPto = this.hasUnapprovedPto.bind(this);
        this.createGridItem = this.createGridItem.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.timecardId !== this.props.timecardId) {
            this.setState({ newExpenses: [] });
        }
        else if (prevProps.vm.expenses.length !== this.props.vm.expenses.length && this.state.newExpenses.length > 0) {
            const existingCodes = this.props.vm.expenses.map(o => o.code);
            console.log(this.props.vm);
            let newExpenses = immutable.fromJS(this.state.newExpenses).toJS();
            let result = newExpenses.filter(e => !existingCodes.includes(e.reasonCode));
            this.setState({ newExpenses: result });
        }

        // Object.entries(this.props).forEach(([key, val]) =>
        //   prevProps[key] !== val && console.log(`Prop '${key}' changed`)
        // );
        // if (this.state) {
        //   Object.entries(this.state).forEach(([key, val]) =>
        //     prevState[key] !== val && console.log(`State '${key}' changed`)
        //   );
        // }
      }

    updateTotal() {
        let vm = this.convertExpenseListToGrid(this.props.vm.expenses);
        let sum = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];  // [Sun, Mon... Sat]

        if (vm.length > 0) {
            sum[0] = vm.reduce((init, val) => init + val.itemDay1.duration, 0);
            sum[1] = vm.reduce((init, val) => init + val.itemDay2.duration, 0);
            sum[2] = vm.reduce((init, val) => init + val.itemDay3.duration, 0);
            sum[3] = vm.reduce((init, val) => init + val.itemDay4.duration, 0);
            sum[4] = vm.reduce((init, val) => init + val.itemDay5.duration, 0);
            sum[5] = vm.reduce((init, val) => init + val.itemDay6.duration, 0);
            sum[6] = vm.reduce((init, val) => init + val.itemDay7.duration, 0);
        }

        // this is intentional to prevent re-render
        this.state.totalHoursDaily = sum;
        this.state.totalHours = sum.reduce((init, val) => init + val, 0);
    }

    validateMisc(misc) {
        let msg = [];
        if (!misc.date.trim()) {
            msg.push("Date is required");
        }

        if (isNaN(misc.time) || misc.time <= 0.0) {
            if (this.props.preloadHolidayHours == true 
                && misc.reasonDescription.toLowerCase().includes("holiday") 
                && misc.time == 0.0) {
                // allow 0 hour entry if it's pre-loaded holiday hours
            } 
            else {
                msg.push("Invalid Hours");
            }
        }

        if (!misc.reasonCode.trim()) {
            msg.push("Reason is required");
        }

        if (!misc.reasonForChange &&
            (this.props.role == 'payroll-admin' || this.props.role == 'supervisor')) {
            msg.push("Reason for Change is required");
        }

        return msg;
    }

    onDeleteMisc(expenseId, onSuccess) {
        const self = this;
        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to delete this record?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is expenseId, expenseId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type: "loading",
                    message: "Deleting Miscellaneous Item. Please wait..."
                });
                ajax.api()
                    .delete("delete-expense/" + s)
                    .then(function (res) {
                        if (self.props.onDeleteMisc) self.props.onDeleteMisc(s);
                        if (onSuccess) onSuccess();
                        self.setState({
                            showMiscDialog: false
                        })
                        context.message({
                            show: false
                        });
                    })
                    .catch(function (err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"
                        });
                    });
            }
        }, expenseId);
    }

    onSaveEmptyMisc(misc) {
        const self = this;

        // we only add empty misc record when there is no existing record with the same reason code, otherwise just delete it
        const sameCodeExists = self.props.vm.expenses.filter(e => 
                    e.code == misc.reasonCode && e.expenseId != misc.expenseId).length > 0;


        const action = misc.expenseId > 0 ? "Updating" : "Adding";
        context.message({
            show: true,
            type: "loading",
            message: `${action} Miscellaneous Item. Please wait...`
        });

        if (misc.expenseId > 0) {
            ajax.api()
                .delete("delete-expense/" + misc.expenseId)
                .then(function (res) {
                    misc.expenseId = -1;
                    if (!sameCodeExists) 
                        self.onSaveMisc(misc);
                    else if (self.props.onDeleteMisc)
                        self.props.onDeleteMisc(misc.expenseId);

                    self.setState({
                        showMiscDialog: false
                    })
                    context.message({
                        show: false
                    });
                })
                .catch(function (err) {
                    const message = err.response.data.exceptionMessage || err.response.data.message;
                    context.message({
                        show: true,
                        type: "error",
                        message: message,
                        buttons: "close"
                    });
                });
        }
        else if (!sameCodeExists) {
            self.onSaveMisc(misc);
        }
        else {
            context.message({ show: false });
        }
    }

    onSaveMisc(misc, onSuccess) {
        const self = this;
        const param = {
            timecardId: this.props.timecardId,
            date: misc.date,
            time: misc.duration,
            reasonCode: misc.reasonCode,
            reasonDescription: misc.reasonDesc,
            note: misc.notes,
            reasonForChange: misc.changeReason
        }
        const expenseId = misc.expenseId;
        const errors = this.validateMisc(param);
        const clone = immutable.fromJS(this.state).toJS();
        if (errors.length > 0) {
            context.message({
                show: true,
                type: "error",
                message: errors.join(" and "),
                buttons: "close"
            });
            return false;
        } 
        
        const action = expenseId > 0 ? "Updating" : "Adding";
        var apiCall = expenseId > 0 ? 
            () => ajax.api().put(`update-expense/${expenseId}`, param) 
            : () => ajax.api().post('add-expense', param);

        if (expenseId <= 0 && param.time == 0)
            apiCall = () => ajax.api().post('add-empty-expense', param);

        context.message({
            show: true,
            type: "loading",
            message: `${action} Miscellaneous Item. Please wait...`
        });

        const apiCallFunc = function () {
                apiCall()
                .then(function (res) {
                    context.message({
                        show: false
                    });

                    if (action === 'Updating') {
                        if (self.props.onUpdateMisc)
                            self.props.onUpdateMisc(expenseId, res.data.expense);
                    }
                    else if (action === 'Adding') {
                        let data = res.data;
                        
                        if (data.isNewTimecardCreated) {
                            if (self.props.onNewTimecardAdded)
                                self.props.onNewTimecardAdded(data.newTimecardId);
                        }
                        else {
                            if (self.props.onAddMisc) 
                                self.props.onAddMisc(data.expense);
                        }
                    }
                    if (onSuccess) onSuccess();

                    clone.showMiscDialog = false;
                    self.setState(clone);
                })
                .catch(function (err) {
                    const data = err.response.data;
                    const msg = data.exceptionMessage || data.message;
                    context.message({
                        show: true,
                        type: "error",
                        message: msg,
                        buttons: "close"
                    });
                });
        };

        if (self.props.role == "payroll-admin") {
            const validateUrl = expenseId > 0 ? `validate-expense/${expenseId}` : 'validate-expense'

            ajax.api()
                .post(validateUrl, param)
                .then(function (res) {
                    apiCallFunc();
                })
                .catch(function (err) {
                    const msg = err.response.data.exceptionMessage || err.response.data.message;
                    if (err.response.data.code == 0x10001) {
                        context.message({
                            show: true,
                            type: "warning",
                            message: <div>
                                <p>{msg}</p>
                                <p>Are you sure to continue?</p>
                            </div>,
                            buttons: "yes,cancel"
                        }, function (button, state) {
                            if (button == "yes") {
                                context.message({
                                    show: true,
                                    type: "loading",
                                    message: `${action} Miscellaneous Item. Please wait...`
                                });
                                apiCallFunc();
                            } else {
                                context.message({
                                    show: false
                                })
                            }
                        });
                    } else {
                        context.message({
                            show: true,
                            type: "error",
                            message: msg,
                            buttons: "close"
                        });
                    }
                });
        } 
        else apiCallFunc();
    }

    onReasonSelected(reasonCode) {
        if (reasonCode == null || reasonCode == "")
            return false;

        let selected = this.props.vm.reasons.filter(o => o.code == reasonCode);
        let current = this.props.vm.expenses;
        let added = immutable.fromJS(this.state.newExpenses).toJS();
        if (selected.length > 0
            && current.filter(o => o.code == reasonCode && o.isPtoCode === false).length == 0 
            && added.filter(o => o.reasonCode == reasonCode).length == 0 ) {

            added.push({
                "reasonCode": selected[0].code,
                "reasonDesc": selected[0].codeName,
                "description": selected[0].codeDescription,
                "isPtoCode": false,
                "itemDay1": { "duration": 0 },
                "itemDay2": { "duration": 0 },
                "itemDay3": { "duration": 0 },
                "itemDay4": { "duration": 0 },
                "itemDay5": { "duration": 0 },
                "itemDay6": { "duration": 0 },
                "itemDay7": { "duration": 0 },
                "durationTotal": 0 
            });

            this.setState({ newExpenses: added });
        }
    }

    onSavePto() {
        // reload Timecard screen
        if (this.props.onDeleteMisc)
            this.props.onDeleteMisc();

        this.setState({ showPtoDialog: false, showPtoListDialog: false });
    }

    openPto(action, ptoId) {
        ptoId = ptoId || 0;
        
        this.setState({
            ptoAction: action,
            showPtoDialog: (ptoId != 0),
            showPtoListDialog: (ptoId == 0),
            ptoDialogTitle: (ptoId == 0 ? "Unapproved Time-Off" : `${action} Time-Off Request`),
            selectedPtoId: ptoId
        });
    }

    approvePto(ptoId) {
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Approving. Please wait..."            
        });

        ajax.api()
            .post('update-pto', { ptoId: ptoId, action: 'approve' })
            .then(function(res){
                // reload Timecard screen
                if (self.props.onDeleteMisc) self.props.onDeleteMisc();

                context.message({
                    show: false
                });
            })
            .catch(function(err) {
                const message = err.response.data.exceptionMessage || err.response.data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: message,
                    buttons: "close"});
            });
    }

    closePto() {
        this.setState({
            showPtoDialog: false,
            showPtoListDialog: false,
            selectedPtoId: null
        });
    }

    deletePtoLine(ptoLineId) {
        const self = this;
        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to delete this time-off request?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is ptoLineId, ptoLineId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type: "loading",
                    message: "Deleting. Please wait..."
                });
                ajax.api()
                    .delete("delete-pto-line/" + s)
                    .then(function (res) {
                        // reload Timecard screen
                        if (self.props.onDeleteMisc) self.props.onDeleteMisc();
                        self.setState({
                            showMiscDialog: false
                        });
                        context.message({
                            show: false
                        });
                    })
                    .catch(function (err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"
                        });
                    });
            }
        }, ptoLineId);
    }

    hasUnapprovedPto() {
        const allowPtoAction = (this.props.vm.isPtoEnabled && this.props.role == "supervisor") || false;
        if (!allowPtoAction)
            return false;
            
        const expenses = this.props.vm.expenses;
        if (expenses.filter(e => e.ptoStatusCode == "Requested").length > 0) {
            this.setState({ showPtoListDialog: true, ptoDialogTitle: "Unapproved Time-Off" });
            return true;
        }
        
        return false;
    }

    openMisc(expenseId, title, content) {
        expenseId = expenseId || 0;

        this.setState({
            showMiscDialog: true,
            miscDialogTitle: title,
            miscDialogContent: content
        });
    }

    closeMisc() {
        this.setState({
            showMiscDialog: false,
            miscDialogTitle: null,
            miscDialogContent: null
        });
    }

    convertExpenseListToGrid(list) {
        if (list == null || list.length == 0)
            return [];

        let grid = [];
        
        // sort by code
        list = list.sort((a, b) => (a.code < b.code? -1: 1));
        var reasons = this.props.vm.reasons;
        var expense = { reasonCode: "", durationTotal: 0 };
        for (var i = 0; i < list.length; i++) {

            const dayNo = moment(list[i].expenseDate).day() + 1; // Sun = 1, Mon = 2... Sat = 7
            const duplicate = (expense.reasonCode === list[i].code && expense[`itemDay${dayNo}`].expenseId != null);

            if (expense.reasonCode != list[i].code || duplicate === true) {
                const prev = expense;
                const empty = { expenseId: null, ptoId: null, ptoLineId: null, ptoStatusCode: null, duration: 0, notes: "", changeReason: "" };
                expense = { 
                    reasonCode: list[i].code, 
                    reasonDesc: list[i].description, 
                    description: "", 
                    isPtoCode: list[i].ptoLineId > 0,
                    itemDay1: {...empty}, 
                    itemDay2: {...empty}, 
                    itemDay3: {...empty}, 
                    itemDay4: {...empty}, 
                    itemDay5: {...empty}, 
                    itemDay6: {...empty}, 
                    itemDay7: {...empty},
                    durationTotal: 0
                };
                expense.durationTotal = list[i].unit;
                expense[`itemDay${dayNo}`].duration = list[i].unit;
                expense[`itemDay${dayNo}`].expenseId = list[i].expenseId;
                expense[`itemDay${dayNo}`].ptoId = list[i].ptoId;
                expense[`itemDay${dayNo}`].ptoLineId = list[i].ptoLineId;
                expense[`itemDay${dayNo}`].ptoStatusCode = list[i].ptoStatusCode;
                expense[`itemDay${dayNo}`].notes = list[i].notes;
                grid.push(expense);

                var reason = reasons.filter(o => o.code == expense.reasonCode);
                if (reason.length > 0)
                    expense.description = reason[0].codeDescription;
                else if (expense.isPtoCode)
                    expense.description = expense.reasonDesc;

                // if duplicate, point back to the original row
                if (duplicate) expense = prev;
            }
            else {
                expense.durationTotal += list[i].unit;
                expense[`itemDay${dayNo}`].duration = list[i].unit;
                expense[`itemDay${dayNo}`].expenseId = list[i].expenseId;
                expense[`itemDay${dayNo}`].ptoId = list[i].ptoId;
                expense[`itemDay${dayNo}`].ptoLineId = list[i].ptoLineId;
                expense[`itemDay${dayNo}`].ptoStatusCode = list[i].ptoStatusCode;
                expense[`itemDay${dayNo}`].notes = list[i].notes;
            }
        }

        return grid;
    }

    createGridItem(dayNo, date, dataItem) {
        const self = this;
        const vm = this.props.vm;
        const isSupervisorOrPayrollAdmin = (this.props.role == "supervisor" || this.props.role == "payroll-admin");
        const action = { 
            addMisc: "addMisc", editMisc: "editMisc", deleteMisc: "deleteMisc", 
            addPto: "addPto", editPto: "editPto", deletePto: "deletePto", approvePto: "approvePto" 
        };

        let allowActions = [];
        if (this.props.allowEdit == true) {
            allowActions.push(action.addMisc, action.deleteMisc, action.editMisc);

            if (vm.isPtoEnabled) {
                if (isSupervisorOrPayrollAdmin)
                    allowActions.push(action.addPto, action.editPto, action.deletePto, action.approvePto);
            }
        }

        let allowEmpty = (this.props.preloadHolidayHours == true && dataItem.reasonDesc.toLowerCase().includes("holiday"));

        let exp = dataItem[`itemDay${dayNo}`];
        exp.date = date;
        exp.reasonCode = dataItem.reasonCode;
        exp.reasonDesc = dataItem.reasonDesc;
        exp.isPtoCode = dataItem.isPtoCode;
        exp.requireChangeReason = isSupervisorOrPayrollAdmin && dataItem.isPtoCode === false;

        return (
            <td className="text-right" key={`${exp.reasonCode}_${dayNo}`}>
                <MiscGridItem key={dayNo} expense={exp} allowEdit={this.props.allowEdit} allowEmpty={allowEmpty}
                    onOpenMisc={util.isMobile() === true ? self.openMisc : null}
                    onCloseMisc={util.isMobile() === true ? self.closeMisc : null}
                    onSaveMisc={allowActions.includes(action.editMisc)? self.onSaveMisc : null} 
                    onSaveEmptyMisc={allowActions.includes(action.editMisc)? self.onSaveEmptyMisc : null} 
                    onDeleteMisc={allowActions.includes(action.deleteMisc)? self.onDeleteMisc : null}
                    onOpenPto={allowActions.includes(action.editPto)? self.openPto : null}
                    onApprovePto={allowActions.includes(action.approvePto)? self.approvePto : null}
                    onDeletePtoLine={allowActions.includes(action.deletePto)? self.deletePtoLine : null} >
                    { 
                        exp.duration.toFixed(2)
                    }
                </MiscGridItem>
            </td>);
    }

    render() {
        this.updateTotal();

        const self = this;
        const isMobile = util.isMobile();
        const vm = this.props.vm;
        const hideTotalHours = this.props.hideTotalHours === true;
        const hideTotalHoursDaily = this.props.hideTotalHoursDaily === true;
        const allowEdit = `${this.props.allowEdit}` == "true";
        const isSupervisorOrPayrollAdmin = (this.props.role == "supervisor" || this.props.role == "payroll-admin");
        const weekDates = util.dayListFromWeekEnding(this.props.weekEnding || vm.weekEnding);

        let expenses = [...this.convertExpenseListToGrid(vm.expenses), ...this.state.newExpenses];
        let items = [];
        
        for(var i=0; i < expenses.length; i++) {
            const dataItem = expenses[i];

            items.push(
                isMobile === true ?

                <div className="row" key={`tr_${i}`}>
                    <div className={`col-xs-12 col-sm-12 ${i % 2 === 0 ? "even" : "odd"}`} key={`tr_sub_${i}`}>
                        <div className="row" >
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-label">
                                    <tbody>
                                    <tr>
                                        <td>{dataItem.reasonDesc}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-item">
                                    <tbody>
                                    <tr>
                                        {
                                            weekDates.map(d => 
                                                <th className="ap-col-title" key={d}>
                                                    <div className="dayName">{moment(d).format("ddd")}</div>
                                                    <div className="dayDate">{moment(d).format("M/D")}</div>
                                                </th>)
                                        }
                                    </tr>
                                    <tr className="ap-color-darkgray">
                                        {
                                            [1,2,3,4,5,6,7].map((dayNo) => {
                                                return self.createGridItem(dayNo, weekDates[dayNo-1], dataItem)
                                            })
                                        }
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> 
                </div>
                :
                <tr className="ap-color-darkgray" key={`tr_${i}`}>   
                    <td className="">
                        {dataItem.reasonDesc}
                    </td>
                    <td className="description">
                        <div className="ap-truncate-text" title={dataItem.description} 
                            dangerouslySetInnerHTML={{ __html: dataItem.description }} />
                    </td>
                    <td className="text-right total-per-row">
                        {dataItem.durationTotal.toFixed(2)}
                    </td>
                    {
                        [1,2,3,4,5,6,7].map((dayNo) => {
                            return self.createGridItem(dayNo, weekDates[dayNo-1], dataItem)
                        })
                    }
                </tr> 
                ); 
        }

        if (allowEdit) {
            let options = [];

            for (let j=0; j < vm.reasons.length; j++) {
                // exclude reasons already in expenses grid
                if (expenses.filter(o => o.reasonCode == vm.reasons[j].code && o.isPtoCode === false).length == 0)
                    options.push(vm.reasons[j]);
            }

            let trReasons = 
                isMobile === true?

                <div className="row" key="tr_add">
                    <div className="col-sm-12 col-xs-12">
                        <table className="list-add">
                            <tbody>
                            <tr>
                                <td>
                                    <FormControl componentClass="select" className="ap-no-margin"
                                        onChange={(evt) => {this.onReasonSelected(evt.target.value);}}>
                                        <option key="" value="">Select Reason</option>
                                        { options.map(r => <option value={r.code} key={r.code}>{r.codeName}</option> )}
                                    </FormControl>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                :
                <tr className="ap-misc-grid-item ap-color-darkgray" key="tr_add">
                    <td className="ap-no-padding">
                        <FormControl componentClass="select" className="ap-no-margin"
                            onChange={(evt) => {this.onReasonSelected(evt.target.value);}}>
                            <option key="" value="">Select Reason</option>
                            { options.map(r => <option value={r.code} key={r.code}>{r.codeName}</option> )}
                        </FormControl>
                    </td>
                    <td colSpan={9}>
                        
                    </td>
                </tr>;

            items.push(trReasons);
        }

        return (
            <div className="container">
            {
                isMobile === true ?

                <div className="row">
                    <div className="col-xs-12 col-sm-12 ap-misc-grid-mobile">
                        {
                            vm.isPtoEnabled && isSupervisorOrPayrollAdmin ?

                            <div className="row">
                                <div className="col-xs-12 col-sm-12 ap-mb-1">
                                    <Button className="primary" onClick={() => self.openPto("create", -1)}>Request Time-Off</Button>
                                </div>
                            </div> : null
                        }
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-title" width="100%">
                                    <tbody>
                                    <tr>
                                        <td>Miscellaneous Time</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                <div className="row" key="tr_head">
                                    <div className="col-xs-12 col-sm-12" key="tr_sub_head"> 
                                        <table className="list-header">
                                            <tbody>
                                            <tr>
                                                <td>Time-Off Type</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {items}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12">
                                <table className="list-footer">
                                    <tbody>
                                    <tr>
                                        <td colSpan={7} className="title">
                                            Daily Total
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.totalHoursDaily[0].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[1].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[2].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[3].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[4].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[5].toFixed(2)}</td>
                                        <td>{this.state.totalHoursDaily[6].toFixed(2)}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <table className="ap-misc-grid">
                            <thead>
                                <tr>
                                    <td className="ap-h4" colSpan={10}>
                                        <div className="title-bar">
                                            <div>
                                                Miscellaneous Time
                                            </div>
                                            <div className={vm.isPtoEnabled && isSupervisorOrPayrollAdmin? "" : "ap-hidden"}>
                                                <Button className="ap-fullsize btn-info" onClick={() => self.openPto("create", -1)}
                                                    disabled={!vm.isPtoEnabled || !isSupervisorOrPayrollAdmin}>Request Time-Off</Button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="ap-misc-grid-header">
                                    <th className="ap-col-title code">
                                        Time Off Type
                                    </th>
                                    <th className="ap-col-title description">
                                        
                                    </th>
                                    <th className="ap-col-title text-center duration">
                                        &#931;
                                    </th>
                                    {
                                        weekDates.map(d => 
                                            <th className="ap-col-title text-center duration" key={d}>
                                                <div className="dayName">{moment(d).format("ddd")}</div>
                                                <div className="dayDate">{moment(d).format("M/D")}</div>
                                            </th>)
                                    }
                                </tr>
                            </thead>

                            <tbody>
                                {items}
                            </tbody>

                            <tfoot className={hideTotalHoursDaily ? "ap-hidden" : ""}>
                                <tr className="ap-misc-grid-footer">   
                                    <td>&nbsp;</td>
                                    <td>Daily Total Hours</td>
                                    <td>&nbsp;</td>
                                    <td className="text-right">{this.state.totalHoursDaily[0].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[1].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[2].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[3].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[4].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[5].toFixed(2)}</td>
                                    <td className="text-right">{this.state.totalHoursDaily[6].toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </table>
                        
                        <div className={hideTotalHours ? "ap-hidden" : "ap-bkg-color-gray ap-color-white ap-summary-container"}>
                            <span className="ap-h4">Miscellaneous Total: </span><span>{util.toHrmString(this.state.totalHours)}</span>
                        </div>
                    </div>
                </div>
            }

                <Modal className="ap-pto-dialog" show={this.state.showPtoDialog} onHide={this.closePto} backdrop="static">
                    <Modal.Header closeButton={true}>
                        <Modal.Title className="ap-pto-dialog-title">
                            <i className="fa fa-calendar-o" /> {this.state.ptoDialogTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PtoDetail ptoId={this.state.selectedPtoId} onSaved={this.onSavePto} onClosed={this.closePto} userRole={this.props.role} action={this.state.ptoAction} timecardId={this.props.timecardId} />
                    </Modal.Body>
                </Modal>

                <Modal className="ap-pto-dialog" show={this.state.showPtoListDialog} onHide={this.closePto} backdrop="static">
                    <Modal.Header closeButton={true}>
                        <Modal.Title className="ap-pto-dialog-title">
                            <i className="fa fa-calendar-o" /> {this.state.ptoDialogTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PtoListByTimecard timecardId={this.props.timecardId} filterStatusCode="Requested" enableSelection={false} onSaved={this.onSavePto} onClosed={this.closePto} />
                    </Modal.Body>
                </Modal>

                <Modal className="ap-misc-grid-dialog" show={this.state.showMiscDialog} onHide={this.closeMisc} backdrop="static">
                    <Modal.Header closeButton={false}>
                        <Modal.Title>
                            {this.state.miscDialogTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.miscDialogContent}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


const MiscGridItem = (props) => {
    const vm = props.expense;
    const isMobile = util.isMobile();

    if (vm.isPtoCode && vm.expenseId == null)
        return props.children;

    const allowTcEdit = (props.allowEdit == true || props.allowEdit == "true");
    const id = `${vm.reasonCode}_${moment(vm.date).day()}`;
    const buttons = [], icons = [];
    const clsButton = isMobile ? "btn btn-default" : "button";

    let overlayRef = useRef(null);
    let durationRef = useRef(null);
    let notesRef = useRef(null);
    let changeReasonRef = useRef(null);

    const fnClosePopover = () => {
        if (isMobile === true)
            props.onCloseMisc();
        else
            overlayRef.current.hide();
    };

    const fnPerform = (action) => {
        if (isMobile === false)
            fnClosePopover();

        if (action == "delete-pto")
            props.onDeletePtoLine(vm.ptoLineId);
        else if (action == "approve-pto")
            props.onApprovePto(vm.ptoId);
        else if (action == "edit-pto")
            props.onOpenPto('edit', vm.ptoId);
        else if (action == "delete-misc")
            props.onDeleteMisc(vm.expenseId);
        else if (action == "save-misc") {
            const misc = {...vm, 
                duration: util.hmStringToUnit(durationRef.value), 
                notes: notesRef.value, 
                changeReason: changeReasonRef.value 
            };

            // setting duration to zero normally will delete the expense
            if (misc.duration === 0) {
                if (props.allowEmpty === true)
                    props.onSaveEmptyMisc(misc);
                else if (vm.expenseId > 0)
                    props.onDeleteMisc(vm.expenseId);
                else
                    props.onSaveMisc(misc);
            }
            else {
                props.onSaveMisc(misc);
            }
        }
        else
            props.onOpenMisc(vm.expenseId, title, content);
    };

    const btn = {
        SaveMisc    : <button key="btnSave" className={`${clsButton} primary`} onClick={() => fnPerform("save-misc")}>{vm.expenseId != null ? "Save" : "Add"}</button>,
        ApprovePto  : <button key="btnApprove" className={`${clsButton} primary`} onClick={() => fnPerform("approve-pto")}>Approve</button>,
        Cancel      : <button key="btnCancel" className={clsButton} onClick={fnClosePopover}>Cancel</button>,
        Close       : <button key="btnClose" className={clsButton} onClick={fnClosePopover}>Close</button>,
        EditPto     : <a key="btnEdit" onClick={() => fnPerform("edit-pto")}><i className='fa fa-edit pull-right ap-clickable'></i></a>,
        DeletePto   : <a key="btnDeletePto" onClick={() => fnPerform("delete-pto")}><i className='fa fa-trash pull-right ap-clickable'></i></a>,
        DeleteMisc  : <a key="btnDeleteMisc" onClick={() => fnPerform("delete-misc")}><i className='fa fa-trash pull-right ap-clickable'></i></a>
    };

    if (allowTcEdit == true) {
        if (vm.ptoLineId > 0) {
            if (vm.ptoStatusCode == "Requested") {
                if (props.onApprovePto) buttons.push(btn.ApprovePto);
                if (props.onOpenPto) icons.push(btn.EditPto);
            }
            if (props.onDeletePtoLine) icons.push(btn.DeletePto);
        } 
        else if (vm.isPtoCode === false) {
            if (props.onSaveMisc) buttons.push(btn.SaveMisc);
            if (props.onDeleteMisc && vm.expenseId > 0) icons.push(btn.DeleteMisc);
        }

        if (buttons.includes(btn.SaveMisc)) buttons.push(btn.Cancel);
    }
    
    // for mobile screen, must have atleast CANCEL or CLOSE button
    if (isMobile && !buttons.includes(btn.Cancel) && !buttons.includes(btn.Close))
    {
        if (buttons.length == 0)
            buttons.push(btn.Close);
        else
            buttons.push(btn.Cancel);
    }

    const clsName = buttons.includes(btn.ApprovePto) ? "ap-misc-grid-item ap-error-color" : "ap-misc-grid-item";
    const tooltip = buttons.includes(btn.ApprovePto) ? "Unapproved Time-Off - Time-Off must be approved before verifying timecard(s)" : "";
    const popupLoc = moment(vm.date).day() < 4 ? "right" : "left"; // Thu, Fri, Sat -- popup appears from left side
    const strDurn = vm.duration > 0 ? util.toShortHmString(vm.duration) : "";
    const txtRows = isMobile ? 4 : 2;

    const title = (
        <React.Fragment>
            <div className="input">
                <FormControl type="text" placeholder="0h 0m" inputRef={ref => durationRef = ref}
                    defaultValue={strDurn} disabled={!buttons.includes(btn.SaveMisc)} />
            </div>
            <div className="icons">
                {icons}
            </div>
        </React.Fragment>
    );

    const content = 
        <div className="ap-vert-flex-container content">
            <div style={style1}>
                <FormControl componentClass="textarea" placeholder={buttons.includes(btn.SaveMisc) ? "Type reason -optional-" : ""} rows={txtRows}
                        inputRef={ref => notesRef = ref} defaultValue={vm.notes} disabled={!buttons.includes(btn.SaveMisc)} />
            </div>
            <div style={style2} className={vm.requireChangeReason ? "" : "ap-hidden"}>
                <ControlLabel>Reason For Change: <span className="ap-color-red">*</span></ControlLabel>
                <FormControl componentClass="textarea" placeholder="" rows={txtRows} inputRef={ref => changeReasonRef = ref} />
            </div>
            <div className={buttons.length > 0 ? "button-group" : "ap-hidden"}>
                {buttons}
            </div>
        </div>;

    const style1 = {
        padding: "5px 0px"
    };

    const style2 = {
        borderTop: "1px solid #EEE",
        padding: "5px 0px"
    };
            
    return (
        isMobile === true ?

        <a className={clsName} onClick={() => fnPerform("open")}>
            {props.children}
        </a>
        :
        <OverlayTrigger id={`miscgriditem_${id}`} ref={overlayRef} trigger="click" placement={popupLoc} rootClose overlay={
            <Popover id={id} title={title} className="ap-misc-popover">
                {content}
            </Popover>}>
            <div className={clsName} title={tooltip}>
                {props.children}
            </div> 
        </OverlayTrigger>
    )
}